import React from 'react'

interface ScreenSize {
  screenHeight: number
  screenWidth: number
}

export const useDetectScreenSize = (): ScreenSize => {
  const [{ height, width }, setSize] = React.useState({
    height: window.screen.height,
    width: window.screen.width,
  })

  React.useEffect(() => {
    const listener = () => {
      setSize({
        height: window.screen.height,
        width: window.screen.width,
      })
    }

    window.addEventListener('resize', listener)

    return () => {
      window.removeEventListener('resize', listener)
    }
  }, [])

  return { screenHeight: height, screenWidth: width }
}
